// temporarily define it here, instead of importing from utils package since vercel is having issues in the build when using utils in thi package!
export const generateUniqueId = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};
export default class Block {
    constructor(config, id, title, widgets) {
        this.config = config;
        this.id = id;
        this.title = title;
        this.widgets = widgets;
        this.uniqueId = "block-" + generateUniqueId();
    }
    getMainWidget() {
        return this.widgets[0];
    }
    getWidgetByLocation(location) {
        var _a;
        if (!((_a = this.widgets) === null || _a === void 0 ? void 0 : _a.length))
            return;
        return this.widgets.find((widget) => widget.location === location);
    }
    getWidgetsByLocation(location) {
        return this.widgets.filter((widget) => widget.location === location);
    }
    getWidgetsByStyle(style) {
        return this.widgets.filter((widget) => widget.style === style);
    }
    getMainWidgetByStyle(style) {
        const widget = this.widgets.find((widget) => widget.style === style);
        return widget ? widget : null;
    }
    addWidget(widget) {
        this.widgets.push(widget);
        return this.widgets.length;
    }
    getUniqueId() {
        return this.uniqueId;
    }
}
